import { BaseMutations } from '@/store/base-mutations';
import { default_staffs_filters } from '@/modules/courses-requests/services';
import { CoursesRequests } from '@/modules/courses-requests/types';
import { EditableCoursesRequest } from '@/modules/courses-requests/store/modules/editable/types';
import EditableCoursesRequestState from './state';

export default class EditableCoursesRequestMutations extends BaseMutations<EditableCoursesRequestState> {
  // ----------------------------------------Dialog----------------------------------------

  TOGGLE_SELECTION_LISTS_LOADING(toggle: boolean) {
    this.state.selection_lists_loading = toggle;
  }

  SET_COURSES(courses: EditableCoursesRequest.Courses) {
    this.state.courses = courses;
  }

  SET_STAFFS(staffs: EditableCoursesRequest.Staff[]) {
    this.state.staffs = staffs;
  }

  // ----------------------------------------Main----------------------------------------

  SET_TYPE(type: EditableCoursesRequest.CoursesTypes | null) {
    this.state.type = type;
  }

  SET_ORGANIZATION(value: number) {
    this.state.organization_id = value;
  }

  CLEAR_ORGANIZATION() {
    this.state.organization_id = null;
  }

  CLEAR_COURSES_REQUEST() {
    this.state.request_id = null;
    this.state.type = null;
    this.state.organization_id = null;
    this.state.edited = false;

    this.state.original_staffs_filter_by_staffs = [];
    this.state.editable_staffs_filter_by_staffs = [];

    this.state.original_staffs_filter_by_courses = [];
    this.state.editable_staffs_filter_by_courses = [];

    this.state.original_staffs = [];
    this.state.editable_staffs = [];

    this.state.original_courses = [];
    this.state.editable_courses = [];
  }

  TOGGLE_SEND(value: boolean) {
    this.state.send = value;
  }

  TOGGLE_EDITED(value: boolean) {
    this.state.edited = value;
  }

  TOGGLE_LOADING(toggle: boolean) {
    this.state.loading = toggle;
  }

  SET_COURSES_REQUEST({
    request_id, type, organization_id, staffs, filters, courses,
  }: {
    request_id: number,
    type: EditableCoursesRequest.CoursesTypes,
    organization_id: number,
    staffs: CoursesRequests.Staff[],
    filters: CoursesRequests.StaffsTableFilters,
    courses: CoursesRequests.Course[],
  }) {
    this.state.request_id = request_id;
    this.state.type = type;
    this.state.organization_id = organization_id;
    this.state.edited = false;

    this.state.original_staffs_filter_by_staffs = [];
    this.state.editable_staffs_filter_by_staffs = [];
    filters.staffs.forEach((filterStaff) => {
      this.state.original_staffs_filter_by_staffs.push({
        id: filterStaff.id,
        name: filterStaff.name,
      });

      this.state.editable_staffs_filter_by_staffs.push({
        id: filterStaff.id,
        name: filterStaff.name,
      });
    });

    this.state.original_staffs_filter_by_courses = [];
    this.state.editable_staffs_filter_by_courses = [];
    filters.courses.forEach((filterCourse) => {
      this.state.original_staffs_filter_by_courses.push({
        id: filterCourse.id,
        title: filterCourse.title,
      });

      this.state.editable_staffs_filter_by_courses.push({
        id: filterCourse.id,
        title: filterCourse.title,
      });
    });

    this.state.original_staffs = [...staffs];
    this.state.editable_staffs = [...staffs];

    this.state.original_courses = [];
    this.state.editable_courses = [];
    courses.forEach((course: CoursesRequests.Course) => {
      this.state.original_courses.push({
        id: course.id,
        title: course.title,
        price: course.price,
        quantity_staff: course.quantity_staff,
      });

      this.state.editable_courses.push({
        id: course.id,
        title: course.title,
        price: course.price,
        quantity_staff: course.quantity_staff,
      });
    });
  }

  SET_ORIGINAL_COURSES_REQUEST() {
    this.state.editable_staffs_filter_by_staffs = [];
    this.state.original_staffs_filter_by_staffs.forEach((filterStaff) => {
      this.state.editable_staffs_filter_by_staffs.push({
        id: filterStaff.id,
        name: filterStaff.name,
      });
    });

    this.state.editable_staffs_filter_by_courses = [];
    this.state.original_staffs_filter_by_courses.forEach((filterCourse) => {
      this.state.editable_staffs_filter_by_courses.push({
        id: filterCourse.id,
        title: filterCourse.title,
      });
    });

    this.state.editable_staffs = [...this.state.original_staffs];
    this.state.editable_courses = [];
    this.state.original_courses.forEach((course: CoursesRequests.Course) => {
      this.state.editable_courses.push({
        id: course.id,
        title: course.title,
        price: course.price,
        quantity_staff: course.quantity_staff,
      });
    });
  }

  // ----------------------------------------Courses----------------------------------------

  ADD_COURSE_TO_SELECTED(item: EditableCoursesRequest.Course | EditableCoursesRequest.Course[]) {
    if (Array.isArray(item)) {
      this.state.selected_courses.push(...item);
    } else {
      this.state.selected_courses.push(<EditableCoursesRequest.Course>item);
    }
  }

  REMOVE_COURSE_FROM_SELECTED(index: number) {
    this.state.selected_courses.splice(index, 1);
  }

  CLEAR_SELECTED_COURSES() {
    this.state.selected_courses = [];
  }

  ADD_COURSE({ course, quantity_staff } : { course: EditableCoursesRequest.Course, quantity_staff: number }) {
    this.state.editable_courses.unshift({
      id: course.id,
      title: course.title,
      price: course.prices?.actual?.base?.rub !== undefined && course.prices.actual.base.rub !== null
        ? course.prices.actual.base.rub : 0,
      quantity_staff,
    });
  }

  REMOVE_COURSE(course_id: number) {
    const requestingCourseIndex = this.state.editable_courses.findIndex((requestingCourse: CoursesRequests.Course) =>
      requestingCourse.id === course_id);

    if (requestingCourseIndex !== -1) {
      this.state.editable_courses.splice(requestingCourseIndex, 1);
    }
  }

  UPD_COURSES_QUANTITY_STAFF({ index, value, action }: { index: number, value: number, action: CoursesRequests.CoursesQuantityStaffActions }) {
    if (action === CoursesRequests.CoursesQuantityStaffActions.INCREASE) {
      this.state.editable_courses[index].quantity_staff += value;
    } else {
      this.state.editable_courses[index].quantity_staff -= value;
    }

    if (this.state.editable_courses[index].quantity_staff < 1) {
      this.state.editable_courses.splice(index, 1);
    }
  }

  // ----------------------------------------Staffs----------------------------------------

  CLEAR_FILTERS() {
    this.state.filters = default_staffs_filters();
  }

  UPD_STAFFS_FILTER_KEY({ key, value }: { key: keyof CoursesRequests.StaffsFilters, value: unknown }) {
    this.state.filters[key] = value;
  }

  ADD_STAFF({ staff, course }: { staff: EditableCoursesRequest.Staff, course: EditableCoursesRequest.Course }) {
    this.state.editable_staffs.unshift({
      staff_id: staff.id !== undefined ? staff.id : null,
      course_id: course.id,
      course_title: course.title,
      staff_email: staff.email,
      staff_name: staff.full_name ?? null,
      staff_phone: staff.phone,
    });

    const staffTableFilterIndex = this.state.editable_staffs_filter_by_staffs.findIndex((staffTableFilterItem: CoursesRequests.StaffsTableFilter) =>
      staffTableFilterItem.id === staff.id);

    if (staffTableFilterIndex === -1) {
      this.state.editable_staffs_filter_by_staffs.unshift({
        id: staff.id !== undefined ? staff.id : null,
        name: staff.full_name ?? null,
      });
    }

    const courseTableFilterIndex = this.state.editable_staffs_filter_by_courses.findIndex((courseTableFilterItem: CoursesRequests.StaffsTableFilter) =>
      courseTableFilterItem.id === course.id);

    if (courseTableFilterIndex === -1) {
      this.state.editable_staffs_filter_by_courses.unshift({
        id: course.id,
        title: course.title,
      });
    }
  }

  REMOVE_STAFFS_BY_COURSE(course_id: number) {
    this.state.editable_staffs = this.state.editable_staffs.filter((staff: CoursesRequests.Staff) =>
      staff.course_id !== course_id);
  }

  REMOVE_STAFF({ id, course_id }: { id: number, course_id: number }) {
    const requestingStaffIndex = this.state.editable_staffs.findIndex((requestingStaff: CoursesRequests.Staff) =>
      requestingStaff.staff_id === id && requestingStaff.course_id === course_id);

    if (requestingStaffIndex !== -1) {
      this.state.editable_staffs.splice(requestingStaffIndex, 1);
    }
  }

  REMOVE_STAFFS_FILTER_ITEM({ filter_type, id }: { filter_type: CoursesRequests.StaffsFiltersTypes, id: number }) {
    let tableFilterIndex;

    if (filter_type === CoursesRequests.StaffsFiltersTypes.STAFFS) {
      tableFilterIndex = this.state.editable_staffs_filter_by_staffs.findIndex((filterItem: CoursesRequests.StaffsTableFilter) =>
        filterItem.id === id);
    } else {
      tableFilterIndex = this.state.editable_staffs_filter_by_courses.findIndex((filterItem: CoursesRequests.StaffsTableFilter) =>
        filterItem.id === id);
    }

    if (tableFilterIndex !== -1) {
      if (filter_type === CoursesRequests.StaffsFiltersTypes.STAFFS) {
        this.state.editable_staffs_filter_by_staffs.splice(tableFilterIndex, 1);
      } else {
        this.state.editable_staffs_filter_by_courses.splice(tableFilterIndex, 1);
      }

      const filter = filter_type === CoursesRequests.StaffsFiltersTypes.COURSES
        ? CoursesRequests.StaffsFiltersTypes.COURSES_IDS : CoursesRequests.StaffsFiltersTypes.STAFFS_IDS;

      const filterItems = this.state.filters[filter];

      if (filterItems !== null && filterItems.length > 0) {
        const filterIndex = filterItems.findIndex((filterItem) => filterItem === id);

        if (filterIndex !== -1) {
          filterItems.splice(filterIndex, 1);
        }
      }
    }
  }

  ADD_STAFF_TO_SELECTED(item: EditableCoursesRequest.Staff | EditableCoursesRequest.Staff[]) {
    if (Array.isArray(item)) {
      this.state.selected_staffs.push(...item);
    } else {
      this.state.selected_staffs.push(<EditableCoursesRequest.Staff>item);
    }
  }

  REMOVE_STAFF_FROM_SELECTED(index: number) {
    this.state.selected_staffs.splice(index, 1);
  }

  CLEAR_SELECTED_STAFFS() {
    this.state.selected_staffs = [];
  }
}
